// ============================================================================
// TENANT USER ENDPOINTS
// ============================================================================
// Endpoint definitions for Tenant User Management module

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Tenant User Endpoints
 * All endpoints are tenant-scoped: /tenants/{tenantId}/users
 */
export const tenantUserEndpoints = {
  /**
   * Get all users for a tenant (paginated)
   * GET /tenants/:tenantId/users
   */
  list: (tenantId: ID) => buildEndpointWithParams('/tenants/:tenantId/users', { tenantId }),

  /**
   * Get user by ID
   * GET /tenants/:tenantId/users/:id
   */
  getById: (tenantId: ID, id: ID) => buildEndpointWithParams('/tenants/:tenantId/users/:id', { tenantId, id }),

  /**
   * Create new user in tenant
   * POST /tenants/:tenantId/users
   */
  create: (tenantId: ID) => buildEndpointWithParams('/tenants/:tenantId/users', { tenantId }),

  /**
   * Update user
   * PUT /tenants/:tenantId/users/:id
   */
  update: (tenantId: ID, id: ID) => buildEndpointWithParams('/tenants/:tenantId/users/:id', { tenantId, id }),

  /**
   * Delete user
   * DELETE /tenants/:tenantId/users/:id
   */
  delete: (tenantId: ID, id: ID) => buildEndpointWithParams('/tenants/:tenantId/users/:id', { tenantId, id }),

  /**
   * Reset user password (admin)
   * PUT /tenants/:tenantId/users/:id/reset-password
   */
  resetPassword: (tenantId: ID, id: ID) => buildEndpointWithParams('/tenants/:tenantId/users/:id/reset-password', { tenantId, id }),
} as const;

/**
 * Export endpoints
 */
export default tenantUserEndpoints;
